import moment from 'moment';
import { TIMEFORMATS } from './constants';

export default (Vue) => {
  Vue.filter('upperFirst', (value) => {
    if (!value) return '';
    value = value.toString();
    return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
  });
  Vue.filter('lowerCase', (value) => {
    if (!value) return '';
    value = value.toString();
    return value.toLowerCase();
  });
  Vue.filter('upperCase', (value) => {
    if (!value) return '';
    value = value.toString();
    return value.toUpperCase();
  });
  Vue.filter('dateFormat', (value, formatType) => moment(value).format(TIMEFORMATS[formatType]));
  Vue.filter('dateFormatUtc', (value, formatType) => moment(value).utc().format(TIMEFORMATS[formatType]));
};
